import React from 'react';
import {
  PieChart as RechartsPieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
} from 'recharts';
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";
import { CATEGORICAL, CHART_MARK_STROKE, CHART_MARK_STROKE_WIDTH } from '../../../helpers/chartPalette';
import usePieChartLayout from '../../../hooks/usePieChartLayout';

const ParagraphMomentPieChart = ({ data, totalResponses }) => {

  const hasCategories =
    data && data[0] && data[0].Categories && data[0].Categories.length > 0;
  // Legenda onder de taart op een smal scherm (gedeelde rapportage op een telefoon).
  const { layout, onResize, ref } = usePieChartLayout(hasCategories ? data[0].Categories.length : 0);
  if (!hasCategories) {
    return <AnalyticsEmptyState />;
  }

  // Convert the Categories array into the format required for the pie chart
  const pieData = data[0].Categories.map((category) => ({
    name: category.Title,
    value: category.Words,
    color: category.Color,
  }));

  // Calculate the total value for percentage calculation
  const totalValue = pieData.reduce((total, entry) => total + entry.value, 0);

  // Custom tooltip content
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, value } = payload[0].payload;
      const percentage = ((value / totalValue) * 100).toFixed(2);
      return (
        <div
          style={{
            backgroundColor: 'white',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '5px',
          }}
        >
          <p style={{ margin: 0, fontWeight: 'bold' }}>{name}</p>
          <p style={{ margin: 0 }}>{`Percentage: ${percentage}%`}</p>
        </div>
      );
    }
    return null;
  };

  // Custom Legend Renderer
  const renderCustomLegend = (props) => {
    const { payload } = props; // Access the legend items
    return (
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {payload.map((entry, index) => (
          <li key={`legend-item-${index}`} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
            <div
              style={{
                width: 12,
                height: 12,
                backgroundColor: entry.color,
                marginRight: 8,
              }}
            ></div>
            <span>{`${entry.payload.name} (${entry.payload.value})`}</span>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div
      ref={ref}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        minHeight: 0,
        width: '100%',
      }}
    >
      <ResponsiveContainer width="100%" height={layout.height} onResize={onResize}>
        <RechartsPieChart>
          <Pie
            data={pieData ? pieData : []}
            cx={layout.cx}
            cy="50%"
            innerRadius={0}
            outerRadius={layout.outerRadius}
            fill={CATEGORICAL[0]}
            paddingAngle={0}
            dataKey="value"
            labelLine={false}
          >
            {pieData && pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color || CATEGORICAL[0]} stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend content={renderCustomLegend} layout={layout.legend.layout} align={layout.legend.align} verticalAlign={layout.legend.verticalAlign} />
        </RechartsPieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ParagraphMomentPieChart;
